<script>
    import _ from 'lodash';
    import {api, api_formdata, api_getcourse, store} from '../stores.js';
    import TopMenu from '../components/TopMenu.svelte';
    import TopMenu_BackBtn from '../components/TopMenu_BackBtn.svelte';
    import TopMenu_EditBtn from '../components/TopMenu_EditBtn.svelte';
    import ImageCDN from '../components/ImageCDN.svelte';
    import LoadingCard from '../components/LoadingCard.svelte';
    import LoadingTabs from '../components/LoadingTabs.svelte';
    
    const user = store('credentials', 'appUserAuth');
    
    export let id = '';
    
    let login = ($user.email ? $user.email : ''),
        password = ($user.pasport ? $user.pasport : ''),
        file = '',
        files = [],
        upload = null;

    const fetchEvent = (async () => {
        let result = await api('getEvent', {idEvent: id});
        let data = result.data ? result.data : [];
        
        if (data) {
            files = data.aktScan ? data.aktScan.split(',') : [];
        }
        
        return data;
    })();
    
    const loadEventMembers = async () => {
        let result = await api('getEventMembers', {idEvent: id, login: $user.email, password: $user.pasport});
        return (result.data ? result.data : []).map((el) => { el.final = +el.final; return el; });
    };
    const loadEventMembersRewards = async () => {
        let result = await api('getEventMembersRewards', {idEvent: id});
        return _.groupBy(result.data, 'idTest');
    };
    
    let fetchEventMembers = loadEventMembers();
    let fetchEventMembersRewards = loadEventMembersRewards();
    
    let idEvent = id,
        idRegPred = ($user.idRegPred ? $user.idRegPred : ''),
        lastname = '',
        firstname = '',
        surname = '',
        tel = '',
        email = '',
        pasport = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 6);
    
    let form_done;
    $: form_done = tel.length && email.length && email.includes('@');

    const handlerMemberAdd = async () => {
        let popup = new bootstrap.Modal(document.getElementById('form-saved'));
        let data = await fetchEvent;
    
        // регистрация пользователя
        await api('addEventMembers', {
            idRegPred,
            name: [lastname, firstname, surname].join(' ').trim(),
            gorod: data.gorod,
            tel,
            email,
            pasport,
        });
    
        // подключение юзера на мероприятие
        await api('saveToEventMembers', {
            idEvent,
            idRegPred,
            email,
            actualnost: 1,
        });
    
        // отправка пользователя в getcourse
        await api_getcourse('user/register', {
            email: email,
            phone: tel,
            first_name: firstname,
            last_name: lastname,
            city: data.gorod,
            partner: ($user.email ? $user.email : ''),
        });
    
        // отправка письма подтверждения
        let fd = new FormData;
            fd.append('email', email);
            fd.append('password', pasport);
    
        await fetch(location.origin + '/form/uspeshnaya-registraciya', {
            method: 'POST',
            body: fd
        });
    
        let fd2 = new FormData;
            fd2.append('email', email);
            fd2.append('name', [lastname, firstname, surname].join(' ').trim());
            fd2.append('title', data.nameProd);
            fd2.append('date', data.datePlan);
            fd2.append('address', data.adres);
            fd2.append('city', data.gorod);
            fd2.append('password', pasport);
    
        await fetch(location.origin + '/form/registraciya-na-meropriyatii', {
            method: 'POST',
            body: fd2
        });
    
        fetchEventMembers = loadEventMembers();
        
        popup.show();
        setTimeout(() => popup.hide(), 2500);
    };
    
    const handlerChangeMemberFinal = async (idMember, state) => {
        let list = await fetchEventMembers;
        let member = list.find(item => item.id === idMember);
    
        if (member) {
            // изменение состояния участника
            await api('saveToEventMembers', {
                idEvent,
                idRegPred,
                email: member.email ? member.email : '',
                actualnost: 1,
                final: state
            });
            
            toastbox('member-attend-' + state, 1500);
        }
    };
    
    let idMember = '';
    const handlerSelectMember = (id) => {
        idMember = id;
    }

    const handlerRemoveBtnClick = () => {
        (new bootstrap.Modal(document.getElementById('member-remove'))).show();
    };

    const handlerMemberRemove = async () => {
        let popup = new bootstrap.Modal(document.getElementById('member-removed'));
        
        if (idMember) {
            let list = await fetchEventMembers;
            let member = list.find(item => item.id === idMember);
    
            if (member) {
                // удаление участника из мероприятия
                await api('saveToEventMembers', {
                    idEvent,
                    idRegPred,
                    email: member.email ? member.email : '',
                    actualnost: 0,
                    final: 0
                });
                document.querySelector('[data-id="' + idMember + '"]').remove();
    
                popup.show();
                setTimeout(() => popup.hide(), 2500);
            }
        }
    };

    const handlerShareEvent = async () => {
        let data = await fetchEvent;

        if (navigator.clipboard.writeText) {
            navigator.clipboard.writeText(
                [
                    data.nameProd,
                    data.name,
                    ['https://app.miin.ru', '/events/view/', id].join('')
                ].join("\n").replaceAll('&quot;', '"')
            );
    
            toastbox('share-link', 1500);
        } else {
            navigator
                .share({
                    title: data.nameProd.replaceAll('&quot;', '"'),
                    text: data.name.replaceAll('&quot;', '"'),
                    url: ['https://app.miin.ru', '/events/view/', id].join(''),
                })
                .then(() => console.debug('Share was successful.'))
                .catch((error) => console.debug('Sharing failed', error));
        }
    };

    const handlerSaveFiles = async () => {
        if (login && password) {
            await api('addEventFiles', {id, login, password, aktScan: files.join(',')});
        }
    };
    
    const handlerRemoveFile = (i) => {
        files = [...files.filter((it, inx) => inx !== i)];
        handlerSaveFiles();
    };
    
    const handlerUploadFile = async () => {
        if (login && password && file && file[0]) {
            let fd = new FormData();
                fd.append('files[document]', file[0]);
            
            let response = upload = await api_formdata('load_file', fd);

            if (response && response.params.data && response.data.document) {
                files = [...files, response.data.document];
                handlerSaveFiles();
            }
        }
    };
    
    let review = '',
        stars = 0;
    const handlerViewMemberRating = (text, count) => {
        review = text;
        stars = count;
    
        let popup = new bootstrap.Modal(document.getElementById('rating-view'));
            popup.show();
    }
</script>

<TopMenu title="Мероприятие">
    <TopMenu_BackBtn slot="back" href="/activity" />
    <button slot="edit" type="button" class="btn btn-link btn-icon" on:click={handlerShareEvent}>
        <ion-icon name="share-social-outline"></ion-icon>
    </button>
  <!--  <button slot="right" type="button" class="btn btn-link btn-icon" data-bs-toggle="modal" data-bs-target="#upload-docs">
        <ion-icon name="cloud-upload-outline"></ion-icon>
    </button>-->
    <TopMenu_EditBtn slot="left" href="/activity/edit/{id}" />
    <button slot="add" type="button" class="btn btn-link btn-icon" data-bs-toggle="offcanvas" data-bs-target="#addMember">
        <ion-icon name="person-add-outline" role="img" class="md hydrated" aria-label="add member"></ion-icon>
    </button>
</TopMenu>

<div id="appCapsule">
    {#await fetchEvent}
        <LoadingCard />
    {:then data}
        <div class="section mt-3 mb-3" style="user-select: none;">
            <div class="row">
                <div class="col-12 col-md-10 col-lg-8 mx-md-auto">
                    <div class="card">
                        {#if data.otherScan}
                            <ImageCDN src="{data.otherScan}" class="card-img-top" alt="{data.nameProd}" style="max-height: 450px;object-fit: cover;" />
                        {/if}
                    
                        <div class="section full">
                            <div class="wide-block transparent p-0">
                                <ul class="nav nav-tabs lined iconed" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-bs-toggle="tab" href="#common" role="tab" aria-selected="false">
                                            Информация
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-bs-toggle="tab" href="#members" role="tab" aria-selected="false">
                                            Участники
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-bs-toggle="tab" href="#rewards" role="tab" aria-selected="false">
                                            Результаты
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    
                        <!-- tab content -->
                        <div class="section full">
                            <div class="tab-content">
                    
                                <!-- common -->
                                <div class="tab-pane fade active show" id="common" role="tabpanel">
                                    <div class="section full">
                                        <div class="wide-block pt-2 pb-2 product-detail-header">
                                            <h1 class="title">{data.nameProd}</h1>
                                           <!-- <div class="detail-footer">
                                                &lt;!&ndash; price &ndash;&gt;
                                                <div class="price">
                                                    <div class="current-price">{((+data.price).toFixed(2))}</div>
                                                </div>
                                                &lt;!&ndash; * price &ndash;&gt;
                                            </div>-->
                                        </div>
                                    </div>
                    
                                    {#if data.name}
                                        <div class="section full mt-2">
                                            <div class="section-title ">Описание</div>
                                            <div class="wide-block pt-2 pb-2">{@html data.name}</div>
                                        </div>
                                    {/if}
                                    {#if data.datePlan && data.timePlan}
                                        <div class="section full mt-2">
                                            <div class="section-title">Дата и время проведения</div>
                                            <div class="wide-block pt-2 pb-2">{data.datePlan} {data.timePlan}</div>
                                        </div>
                                    {/if}
                                    {#if data.adres}
                                        <div class="section full mt-2">
                                            <div class="section-title">Адрес</div>
                                            <div class="wide-block pt-2 pb-2">{data.adres}</div>
                                        </div>
                                    {/if}
                                    {#if data.mest}
                                        <div class="section full mt-2">
                                            <div class="section-title">Всего мест</div>
                                            <div class="wide-block pt-2 pb-2">{data.mest}</div>
                                        </div>
                                        <div class="section full mt-2">
                                            <div class="section-title">Доступно мест</div>
                                            <div class="wide-block pt-2 pb-2">{data.mest - data.members}</div>
                                        </div>
                                    {/if}
                                    {#if data.komment}
                                        <div class="section full mt-2">
                                            <div class="section-title">Комментарий</div>
                                            <div class="wide-block pt-2 pb-2">{data.komment}</div>
                                        </div>
                                    {/if}
                                </div>
                                <!-- * common -->
                    
                                <!--  members -->
                                <div class="tab-pane fade" id="members" role="tabpanel">
                                    {#await fetchEventMembers}
                                        <LoadingTabs />
                                    {:then data}
                                        <ul class="listview image-listview">
                                            {#each data as {id, name, email, tel, oplata, dataOplat, final, otziv, rating}}
                                                <li>
                                                    <div class="item" data-id="{id}">
                                                        <div class="in">
                                                            <div style="width: 40%">
                                                                {name}
                                                                <br>
                                                                <a href="tel:{tel}" class="text-muted">{tel}</a>
                                                                <br>
                                                                <span class="text-muted">{email}</span>
                                                            </div>
    
                                                            <button type="button" class="btn btn-outline-primary" on:click={() => otziv ? handlerViewMemberRating(otziv, rating) : ''}>
                                                                {#each {length: 5} as _, i}
                                                                    <i class="{i < rating ? 'fas' : 'far'} fa-star"></i>
                                                                {/each}
                                                            </button>
    
                                                            <div class="d-flex align-items-center">
                                                                <div class="form-check form-switch d-inline-block">
                                                                    <input class="form-check-input" type="checkbox" id="switch-attend-{id}" bind:checked={final} on:change={(e) => handlerChangeMemberFinal(id, +e.currentTarget.checked)}>
                                                                    <label class="form-check-label" for="switch-attend-{id}"></label>
                                                                </div>
                                                                
                                                                <button type="button" class="btn btn-link btn-icon d-inline-block" data-bs-toggle="offcanvas" data-bs-target="#memberMenu" on:click={() => handlerSelectMember(id)}>
                                                                    <ion-icon name="options-outline"></ion-icon>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            {/each}
                                        </ul>
                                    {/await}
                                </div>
                                <!-- * members -->
                                
                                <!--  rewards -->
                                <div class="tab-pane fade" id="rewards" role="tabpanel">
                                    {#await fetchEventMembersRewards}
                                        <LoadingTabs />
                                    {:then data}
                                        <div id="accordion-reward">
                                            {#each Object.entries(data ? data : {}) as [id, group]}
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordion-{id}" aria-expanded="false">
                                                        {@html group && group.length ? group[0].nameTest : 'Результаты ' + id }
                                                    </button>
                                                </h2>
                                                <div id="accordion-{id}" class="accordion-collapse collapse" data-bs-parent="#accordion-reward">
                                                    <div class="accordion-body p-0">
                                                        <ul class="listview image-listview">
                                                            {#each group as {id, name, email, nameTest, test, state}}
                                                                <li class="pl-3">
                                                                    <div class="item">
                                                                        <div class="in">
                                                                            <div style="width: 40%">
                                                                                {name}<br>
                                                                                <span class="text-muted">{email}</span>
                                                                            </div>
                            
                                                                            <div class="d-flex align-items-center">
                                                                                {+test ? test + ' МИИН\'ок' : state}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            {/each}
                                                        </ul>
                                                    </div>
                                                </div>
                                            {/each}
                                        </div>
                                    {/await}
                                </div>
                                <!-- * rewards -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <!-- Upload files -->
        <div class="modal fade modalbox" id="upload-docs" data-bs-backdrop="static" tabindex="-1" role="dialog" aria-modal="true" style="display: none;">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Загрузка файлов, актов и фотографий</h5>
                        <a href="#" data-bs-dismiss="modal">Закрыть</a>
                    </div>
                    <div class="modal-body">
                        {#if files.length > 0}
                            <div class="listview-title">Загруженные файлы</div>
                            <ul class="listview image-listview mb-2">
                                {#each files as url, i}
                                    <li>
                                        <div class="item">
                                            <div class="in">
                                                <div class="col-8 overflow-hidden text-nowrap">{url}</div>
                                                <span class="col-4 d-flex justify-content-end">
                                                    <a href="https://225304.selcdn.ru/miin/{url}" download="{url}" class="btn btn-secondary btn-sm btn-icon" style="margin-right: 5px;">
                                                        <ion-icon name="cloud-download-outline" role="img" class="md hydrated" aria-label="download"></ion-icon>
                                                    </a>
                                                    <button type="button" class="btn btn-danger btn-sm btn-icon" on:click={() => handlerRemoveFile(i)}>
                                                        <ion-icon name="trash-outline" role="img" class="md hydrated" aria-label="remove"></ion-icon>
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                {/each}
                            </ul>
                        {/if}
                        
                        <div class="row">
                            <div class="col-12">
                                <div class="custom-file-upload" id="fileUpload1">
                                    <input type="file" id="otherScan" name="files[otherScan]" bind:files={file} on:change={handlerUploadFile}>
                                
                                    <label for="otherScan">
                                        <span>
                                            <strong>
                                                <ion-icon name="cloud-upload-outline" role="img" class="md hydrated" aria-label="Файл"></ion-icon>
                                                <i>Загрузить файл</i>
                                            </strong>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- * Upload files -->
    {/await}
    
    <!-- Form Add Member Sheet -->
    <div class="offcanvas offcanvas-bottom action-sheet inset" tabindex="-1" id="addMember">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title">Добавление участника</h5>
        </div>
        <div class="offcanvas-body">
            <div class="action-sheet-content">
                <form>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="form-label" for="lastname">Фамилия</label>
                            <input type="text" class="form-control" id="lastname" name="lastname" autocomplete="off" bind:value={lastname}>
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="form-label" for="firstname">Имя</label>
                            <input type="text" class="form-control" id="firstname" name="firstname" autocomplete="off" bind:value={firstname}>
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="form-label" for="surname">Отчество</label>
                            <input type="text" class="form-control" id="surname" name="surname" autocomplete="off" bind:value={surname}>
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="form-label" for="tel">Телефон <span class="text-danger">*</span></label>
                            <input type="tel" class="form-control" id="tel" name="tel" autocomplete="off" bind:value={tel} required>
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="form-label" for="email">E-Mail <span class="text-danger">*</span></label>
                            <input type="email" class="form-control" id="email" name="email" autocomplete="off" bind:value={email} required>
                        </div>
                    </div>
                    
                    <div class="form-group basic">
                        {#if form_done}
                            <button type="button" class="btn btn-primary btn-block" data-bs-dismiss="offcanvas" on:click={handlerMemberAdd}>Добавить</button>
                        {:else}
                            <button type="button" class="btn btn-primary btn-block" disabled>Добавить</button>
                        {/if}
                    </div>
                </form>
            </div>
        </div>
    </div>
    <!-- * Form Add Member Sheet -->
    
    <!-- Action Member Sheet -->
    <div class="offcanvas offcanvas-bottom action-sheet inset" tabindex="-1" id="memberMenu">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title">Действия с участником</h5>
        </div>
        <div class="offcanvas-body">
            <ul class="action-button-list">
                <li>
                    <button type="button" class="btn btn-list" data-bs-dismiss="offcanvas" on:click={handlerRemoveBtnClick}>
                        <span>
                            <ion-icon name="trash-outline" role="img" class="md hydrated" aria-label="trash outline"></ion-icon>
                            Удалить
                        </span>
                    </button>
                </li>
                <li class="action-divider"></li>
                <li>
                    <button type="button" class="btn btn-list text-danger" data-bs-dismiss="offcanvas">
                        <span>
                            <ion-icon name="close-outline"></ion-icon>
                            Закрыть
                        </span>
                    </button>
                </li>
            </ul>
        </div>
    </div>
    <!-- * Action Member Sheet -->
    
    <div class="modal fade dialogbox" id="form-saved" data-bs-backdrop="static" tabindex="-1" style="display: none;" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-icon text-success">
                    <ion-icon name="checkmark-circle" role="img" class="md hydrated" aria-label="checkmark circle"></ion-icon>
                </div>
                <div class="modal-header">
                    <h5 class="modal-title">Участник добавлен</h5>
                </div>
                <div class="modal-footer">
                    <div class="btn-inline">
                        <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Dialog Event Remove -->
    <div class="modal fade dialogbox" id="member-remove" data-bs-backdrop="static" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Вы уверены?</h5>
                </div>
                <div class="modal-body">
                    Это действие приведёт<br>
                    к удалению участника
                </div>
                <div class="modal-footer">
                    <div class="btn-inline">
                        <button type="button" class="btn btn-text-danger" data-bs-dismiss="modal" on:click={handlerMemberRemove}>
                            <ion-icon name="trash-outline"></ion-icon>
                            Удалить
                        </button>
                        <button type="button" class="btn" data-bs-dismiss="modal">
                            <ion-icon name="ban-outline"></ion-icon>
                            Отмена
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * Dialog Event Remove -->
    
    <!-- Rating view -->
    <div class="modal fade dialogbox" id="rating-view" data-bs-backdrop="static" tabindex="-1" style="display: none;" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Оценка участника</h5>
                </div>
                <div class="modal-body mb-1">
                    {#each {length: 5} as _, i}
                        <i class="{i < stars ? 'fas' : 'far'} fa-star"></i>
                    {/each}
                </div>
                <div class="modal-body">{review}</div>
                <div class="modal-footer">
                    <div class="btn-inline">
                        <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * Rating view -->
    
    <!-- Member removed -->
    <div class="modal fade dialogbox" id="member-removed" data-bs-backdrop="static" tabindex="-1" style="display: none;" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-icon text-success">
                    <ion-icon name="checkmark-circle" role="img" class="md hydrated" aria-label="checkmark circle"></ion-icon>
                </div>
                <div class="modal-header">
                    <h5 class="modal-title">Участник удалён</h5>
                </div>
                <div class="modal-footer">
                    <div class="btn-inline">
                        <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * Member removed -->
    
    <!-- Member toasts -->
    <div id="member-attend-1" class="toast-box toast-top bg-primary">
        <div class="in">
            <div class="text">
                Участник отмечен
            </div>
        </div>
    </div>
    <div id="member-attend-0" class="toast-box toast-top bg-secondary">
        <div class="in">
            <div class="text">
                Участник исключен
            </div>
        </div>
    </div>
    <!-- * Member toasts -->
    
    <!-- Share -->
    <div id="share-link" class="toast-box toast-top bg-primary">
        <div class="in">
            <div class="text">
                Ссылка скопирована
            </div>
        </div>
    </div>
    <!-- * Member toasts -->
</div>
